export const normalizeItem = (raw) => ({
  id: raw?.id,
  key: raw?.key,
  name: raw?.name,
  type: raw?.type, // 'image' | 'audio' | 'video' | 'doc'
  mimeType: raw?.mimeType,
  size: Number(raw?.size || 0),
  created: raw?.created,
  signedUrl: raw?.signedUrl || null,
  thumbnailUrl: raw?.thumbnailUrl || null,
});

export const selectAllProjectItems = (state) => {
  const logObj = {};
  for (const item of state.project?.items || []) {
    switch (item.type) {
      case 'image':
        logObj.images = logObj.images || [];
        logObj.images.push({
          id: item.id,
          name: item.name,
          signedUrl: item.signedUrl,
          key: item.key,
        });
        break;
      case 'audio':
        logObj.audios = logObj.audios || [];
        logObj.audios.push({
          id: item.id,
          name: item.name,
          signedUrl: item.signedUrl,
          key: item.key,
        });
        break;
      case 'video':
        logObj.videos = logObj.videos || [];
        logObj.videos.push({
          id: item.id,
          name: item.name,
          signedUrl: item.signedUrl,
          key: item.key,
        });
        break;
      default:
      // ignore
    }
  }

  return (state.project?.items || []).map(normalizeItem);
};

// Filter helpers
export const selectImages = (state) => {
  return selectAllProjectItems(state).filter((it) => it.type === 'image');
};

export const selectAudios = (state) =>
  selectAllProjectItems(state).filter((it) => it.type === 'audio');

export const selectVideos = (state) =>
  selectAllProjectItems(state).filter((it) => it.type === 'video');

// Resolve one by id, returning normalized or null
export const selectItemById = (state, id) =>
  selectAllProjectItems(state).find((it) => it.id === id) || null;

export const selectItemByNameAndType = (state, name, type) =>
  selectAllProjectItems(state).find((it) => it.name === name && it.type === type) || null;